import React, { Component } from 'react';
import { Session, NavBar, CarouselDashboard, Slider, Footer, MenuCategories, ItemsList, ItemSlider, ItemSliderResponsive, Suscription, TopNavBar, CarouselTrademarks, DejanosMensajeModal,ItemSlider1,ItemSlider2, } from '../../components';
import { config, VIEW_NAME, SERVICE_API, DISPATCH_ID, ROLES  } from '../../libs/utils/Const';
import { connect } from "react-redux";
import { Prueba } from '../../components/MenuCategories';
import { ApiClient } from "../../libs/apiClient/ApiClient";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './Categories.css';
import $ from "jquery";

const apiClient = ApiClient.getInstance();
const responsiveCategories = {  
    /* Resolucion configuracion del responsivo del carrusel de productos*/
    desktop: {
        breakpoint: { max: 3000, min: 1920 },
        items: 5,
        partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
    },
    desktop2: {
        breakpoint: { max: 1920, min: 1200 },
        items: 4,
        partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
    },
    tablet: {
        breakpoint: { max: 1200, min: 1070 },
        items: 4,
        partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
    },
    tablet1: {
        breakpoint: { max: 1070, min: 767 },
        items: 3,
        partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
    },
    tablet2: {
        breakpoint: { max: 767, min: 464 },
        items: 2,
        partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
        },
    mobile: {
        breakpoint: { max: 463, min: 0 },
        items: 1,
        partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
    }
  }

class DashboardView extends Component {
    //Crearla funcion ene le store procedure para trear el baner de enmedio
    //en el back, genearar la función par apoder consultarl, similar a lo de categorias ygen errar su ruta
    //front, generar la funcion en Apiclient, g¿enerar la variabla para la ruta de la funcion crada para poder consultar la imgane del banner de enmedio
    state = {
        itemsPromociones: [],//CODIGO DEL PRODUCTO EN UN ARREGLO DE DASH
        itemsNuevos: [],
        items: [],
        categories: [],
        banner: [],
    }
    async componentDidMount() {
        const { sessionReducer: {role}, enableSpinner, itemsReducer:{nextPage}, Spinner, setItemsSearch, configReducer: { history }, setItemsFilterSearch, searchByDash, searchByDashOption,setUserSession, sessionReducer } = this.props;
        searchByDash(this.handelSubmit);
        enableSpinner(true);
        let whs = '';
        let user = {};
        let newUser = sessionReducer.user;

        console.log('conF ########### user ',newUser);
        newUser.U_Canal_SN = '01';
        newUser.wareHouse = '01';
        console.log('conF ########### newUser ',newUser);
        setUserSession(newUser);
        try {
            user = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
            whs = user.U_FMB_Handel_ALMA || '';
        } catch (error) {
            whs = '01'
        }
        let localShoppingCart = undefined;
        if (role === ROLES.PUBLIC) {
            localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
            localShoppingCart = JSON.parse(localShoppingCart) || [];
        }
        // Categorias para mostrar al inicio del modelo
        await apiClient.getCategoriesHome('home').then(result => {
            this.setState({
                categories: result.data,
            });
        });

        // Busqueda de los banners para el inicio
        await apiClient.getBannerHome().then(result => {
            this.setState({
                banner: result.data,
            });
        });

      
        // Busqueda de nuevo producto

        // let busqueda2 = {
        //     contenido: {
        //         opcion: "nuevosproductos",
        //         limit: 20
        //     }
        // };
      
     
        // await apiClient.ProductsEspecial(busqueda2,localShoppingCart, whs, 0).then(result => {

        //     this.setState({
        //         itemsPromociones: result.data.responseBody,
        //         itemsNuevos: result.data.responseBody2,
        //     });
        // });
        enableSpinner(false);
    }

    //Arrows o bien con funiciones declaradas

    // mostrarCategoria = (valor) => {
    //     //Estamos haciendo uso de props del sistema
    //     const {setCategory,setIdCategory, setLocation,itemsReducer: {searchByCategories},setNextPage, itemsReducer} = this.props;
    //     console.log("restar",itemsReducer);
    //     setIdCategory(valor);
    //     setNextPage(0);
    //     setLocation('menuCategories');
    //     searchByCategories(valor,0,'home');
    // };
    mostrarCategoria = async(valor,seccion, subCategory = null) => {
        const {setIdCategory, setLocation,itemsReducer: {searchByCategories},setNextPage} = this.props;
        await setIdCategory(valor);
        await setNextPage(0); 
        await setLocation('menuCategories');
        searchByCategories(valor,0,seccion, subCategory);
    };

    changeQuantity = (index, item, newQuantity, addItem) => {
        const { itemsReducer: { addShoppingCart, deleteShoppingCart } } = this.props;
        if (addItem) {
            // addShoppingCart({ item, quantity: (newQuantity || '1') })
            addShoppingCart({
                item, quantity: (newQuantity && (!item.SalPackUn || Number(item.SalPackUn) === 1 || (item.SalUnitMsr === 'KG' && newQuantity > 1)) ? newQuantity
                    : item.SalPackUn && item.SalPackUn > 1 && item.SalUnitMsr === 'KG' ? item.SalPackUn :
                        item.SalPackUn && item.SalPackUn > 1 && (!Number(newQuantity) || (Number(newQuantity) === 1)) ? item.SalPackUn : newQuantity || '1')
            });
        } else {
            deleteShoppingCart({ item, deleteAll: false });
        }
    };

    changeBackOrder = (item, addItem) => {
        const { itemsReducer: { deleteBackOrder, addBackOrder } } = this.props;
        if (addItem) {
            addBackOrder({ item, quantity: 1 })
        } else {
            deleteBackOrder({ item, deleteAll: false });
        }
    };

    handelSubmit = async (opcion,page = 0) => {
        const { sessionReducer: {role}, enableSpinner, itemsReducer:{nextPage}, setTotalRows, setItemsSearch, configReducer: { history }, setItemsFilterSearch, setLocation, searchByDashOption } = this.props;
        //console.log("Valor boton", opcion);

        let whs = '';
        let user = {};
        try {
            user = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
            whs = user.U_FMB_Handel_ALMA || '';
        } catch (error) {
            whs = '01'
        }
        let localShoppingCart = undefined;
        if (role === ROLES.PUBLIC) {
            localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
            localShoppingCart = JSON.parse(localShoppingCart) || [];
        }
        //Hace la petición al back
        let busqueda = {
            contenido: {
                opcion: opcion
            }
        };
        setLocation('dash');
        searchByDashOption(opcion);

        enableSpinner(true);
        await apiClient.getProductsEspecial(busqueda,localShoppingCart, whs, page).then(result => {
            // console.log(result);
            enableSpinner(false);
            setItemsSearch(result.data.responseBody);
            setItemsFilterSearch(result.data.responseBody);
            setTotalRows(result.data.totalRows);
            history.goItems();
            return;
        });
        //Validamos la respuesta del Back
    };

    redirectMulos = async () => {
        const { configReducer: { history }} = this.props;
        const {itemsReducer,setIdCategory,setLocation} = this.props;
        setIdCategory(null);
        setLocation('Mulos');
        await itemsReducer.searchByKey(0,'Mulos');
    };
   
    redirectAboutRedZone = async () => {
        const { configReducer: { history } } = this.props;
        history.goAboutRedZone();
    };

    redirectPaymentMethod = async () => {
        const { configReducer: { history } } = this.props;
        history.goPaymentMethodView();
    };

    redirectSafeShopping = async () => {
        const { configReducer: { history } } = this.props;
        history.goSafeShopping();
    };

    redirectNewsBlog = async () => {
        const { configReducer: { history } } = this.props;
        history.goNewsBlog();
    };

    redirectAboutUs = async () => {
        const { configReducer: { history } } = this.props;
        history.goAboutUs();
    };

    redirectCotizacion = async () => {
        setTimeout(() => {
            $('#dejanosMensajeModal').modal('show');
        }, 300);  
    };

    redirectgoHome = async () => {
        const { configReducer: { history } } = this.props;
        history.goHome();
    };

    redirectRedStock = async () => {
        return (
            <a href={`${config.BASE_URL}/${SERVICE_API.getPolitics}/${config.pdf.politicasEnviosGarantias}`} target="_blank" ></a>
        )
    };

    VerMas = (name)=>{
        let result = '';
        switch (name) {
            case 'Nosotros':
                result = (this.redirectAboutUs);
                break;
            case 'BlogNoticias':
                result = (this.redirectNewsBlog);
                break;
            case 'Cotizacion':
                result = (this.redirectCotizacion);
                break;
            case 'Mulos':
                result = (this.redirectMulos);
                break;
            
            
            default:
                result = (this.redirectgoHome);
                break;
        }
        return result
    }

    //Render va pintar el codigo html que ingresemos en la funcion return 
    render() {
        const { history, itemsReducer: { updateFavorite, deleteShoppingCart, openItemDetails,items1,items2 },sessionReducer: { user }, sessionReducer } = this.props;
        const { categories, items, banner, itemsPromociones, itemsNuevos } = this.state;     
        return (

            <div className="container-fluid" style={{ marginTop: 100, backgroundColor: "#FFFFFF", paddingLeft:0, paddingRight:0 }}>
                <Session history={history} view={VIEW_NAME.DASHBOARD_VIEW} />
                <NavBar />
                <DejanosMensajeModal
                    Usuario={user}
                    datos = {sessionReducer.role}
                ></DejanosMensajeModal>
                {/* 117 */}
                <div className="overflow-auto" style={config.NuevosEstilos.background}>
                {/* Si es un video */}
                {config.dashboard === 'Video' && <Slider />}
                {/* Si es un video */}
                {config.dashboard === 'Carousel' && <CarouselDashboard />}
                <TopNavBar/>
                <div className="text-justify col-md-12">
                    <p style={{marginBottom:"7rem"}}><br></br></p>
                    <p className="titulodeSeccionRefacciones">Categorías</p>
                </div>
                <div className="col-12">
                    <Carousel autoPlay infinite={true} draggable={true} responsive={responsiveCategories} autoPlaySpeed={2500} removeArrowOnDeviceType={["tablet", "mobile","tablet1","tablet2"]}>
                        {categories &&
                            categories.length !== 0 &&
                            categories.map((categoria, index) => {
                                return (
                                    <div style={{ textAlign: "center",display: 'flex', justifyContent:'center', margin: 0}} key={index}>
                                        <div className="item carousel-DashBoard-img" style={{wordWrap:"break-word", width: "13rem", height: "521.733px", background: 'transparent', border: "none"}} onClick={() => this.mostrarCategoria(categoria.idCategory,'menu2')}>
                                            <div>
                                            <img className="card-img-top" style={{ width: "100%", height: "350px", cursor: "pointer", background: 'transparent', borderRadius:".8rem",marginBottom: ".5rem" }} src={categoria.image ? (config.BASE_URL + SERVICE_API.getImageCategories + '/' + categoria.image) : require("../../images/noImage.png")} />
                                            </div>
                                            <div className="card-body" style={{ margin: 0, padding: 0, color: config.itemsList.textColor2 }}>
                                                <div className="overflow-auto">
                                                    <p className="card-title font-weight-bold text-center" style={{ margin: 0, padding: 0, fontSize: 16, height: '3rem' }}>
                                                        {categoria.itemCode}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </Carousel>
                </div><br></br>


                <div className="text-justify col-md-12">
                    <p><br></br></p>
                    <p className="titulodeSeccionPromoRed" style={{marginTop:"39px", marginBottom:"13px"}} >Promociones</p>
                </div>
                <div style={{ padding: 15}}>
                    <div className="PromoRedSlider" style={{ paddingTop: 10, margin: 0, justifyContent: "center", alignItems: "center" }}>
                    {items1 &&
                            items1.length !== 0 ? (
                                <ItemSlider1 changeQuantity={this.changeQuantity} dashboard={10} changeBackOrder={this.changeBackOrder}/>
                            ) : (
                                <div style={{ paddingTop: 100, margin: 0, textAlign: "center" }}>No hay artículos disponibles de momento:
                                    <br />
                                    <br />
                                    <i style={{ fontSize: 70 }} className={config.icons.search}></i>
                                </div>
                            )}
                    </div>
                </div>
                <div className="text-justify col-md-12">
                    <p><br></br></p>
                    <p className="titulodeSeccionDescubre">Descubre</p>
                </div>
                {/* 117 */}
                <div style={{ paddingTop: 30}}>
                    <div className="cardsDescubre col-lg-12 row" style={{ color: "white"}}>
                    {banner.length !== 0 &&
                            banner.map((ban,index)=>{
                                return (
                                    ban.active === "on" &&
                                        ban.Name === "Informacion" ?
                                        <div className="col-lg-6 col_personalizado pb-2" key={index}>
                                            <div className="ConoceTarjeta card img-fluid" style={{border: 'none', background: "transparent"}}>
                                                <img
                                                    className="card-img-top"
                                                    src={ban.image ? (config.BASE_URL + SERVICE_API.getImageCategories + '/' + ban.image) : require('../../images/noImage.png')}
                                                    alt="Card image"
                                                    style={{width:"100%"}}></img>
                                            </div>
                                        </div>
                                        :
                                        <div className="col-lg-6 col-md-6 pb-3 pr-0" key={index}>
                                            <div className="ConoceTarjeta card img-fluid" style={{border: 'none', background: "transparent"}}>
                                                <img 
                                                    className="card-img-top" 
                                                    src={ban.image ? (config.BASE_URL + SERVICE_API.getImageCategories + '/' + ban.image) : require('../../images/noImage.png')}
                                                    alt="Card image" 
                                                    style={{width:"100%"}}></img>
                                                <div className="card-img-overlay">
                                                    <a onClick={this.VerMas(ban.Name)} className="btn text-black" 
                                                    style={{background: "#FFED00", color: "black !impor" ,marginTop: '5%', marginLeft:'85%', cursor:'auto'}}>
                                                        {ban.Name === 'Cotizacion' ? 'Ir a cotizar' : 'Ver más'}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="text-justify col-md-12">
                    <p><br></br></p>
                    <p className="titulodeSeccionNuevosProductos">Nuevos productos</p>
                </div>
                <div style={{ padding: 15}}>
                    <div style={{ paddingTop: 30, margin: 0, justifyContent: "center", alignItems: "center" }}>
                    {items2 &&
                            items2.length !== 0 ? (
                                // <ItemSlider
                                //     items={itemsNuevos}
                                //     updateFavorite={updateFavorite}
                                //     openDetails={openItemDetails}
                                //     changeQuantity={this.changeQuantity}
                                //     deleteShoppingCart={deleteShoppingCart}
                                //     changeBackOrder={this.changeBackOrder}
                                //     dashboard={20}
                                // />
                                <ItemSlider2 changeQuantity={this.changeQuantity} dashboard={10} changeBackOrder={this.changeBackOrder}/>
                            ) : (
                                <div style={{ paddingTop: 100, margin: 0, textAlign: "center" }}>No hay artículos disponibles de momento:
                                    <br />
                                    <br />
                                    <i style={{ fontSize: 70 }} className={config.icons.search}></i>
                                </div>
                            )}
                    </div>
                </div>
                {/* <div className="envios col-lg-12 row mt-4 text-center pt-4 pb-4">
                    <div className="pagosTarjeta col-lg-4 col-md-4 img-fluid">
                        <img src={config.trademarks.pagoTarjeta} style={{width: "120px"} }></img>
                        <h5 className="colorText mt-2 font-weight-bold">Paga con tarjeta de crédito o débito</h5>
                        <p className="colorText">Realizar tus pagos de manera segura <br/> en nuestra plataforma.</p><br/>
                        <a className="font-weight-bold colorText" onClick={this.redirectPaymentMethod}>¿Cómo pagar con E-HANDEL?</a>
                    </div>
                    <div className="enviosRepublica col-lg-4 col-md-4 img-fluid">
                        <img src={config.trademarks.enviosRepublica} style={{width: "167px"} }></img>
                        <h5 className="colorText mt-2 font-weight-bold">Envíos a toda la República Mexicana</h5>
                        <p className="colorText">No importa en qué parte de México estés, <br/> nosotros te lo enviamos.</p><br/>
                    </div>
                    <div className="comprasSeguras col-lg-4 col-md-4 img-fluid">
                        <img src={config.trademarks.comprasSeguras} style={{width: "112px"} }></img>
                        <h5 className="colorText mt-2 font-weight-bold">Compras seguras</h5>
                        <p className="colorText">Realizar tus pagos de manera segura <br/> en nuestra plataforma.</p><br/>
                        <a className="font-weight-bold" onClick={this.redirectSafeShopping}>Conoce más sobre nuestros métodos de pagos</a>
                    </div>
                </div> */}

                {/* sección de marcas */}
                <div className="text-center my-1">
                    <CarouselTrademarks/>
                </div>
                {/* <Suscription/> */}
                </div >
            </div >
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer
    };
};


const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setItemsSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SET_ITEMS, value }),
        setItemsFilterSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value }),
        setTotalRows : value => dispatch({type: DISPATCH_ID.ITEMS_SET_TOTALROWS, value}),
        setItemsCategories: value => dispatch({type: DISPATCH_ID.ITEMS_SET_CATEGORIES, value}), 
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setDashboard:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_DASH, value}),
        searchByDash:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH, value}),
        searchByDashOption: value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH_OPTION, value}),
        setCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_CATEGORY, value}),
        setIdCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_IDCATEGORY, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
        setUserSession: value => dispatch({type: DISPATCH_ID.SESSION_SET_USER, value}),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardView);